/**
 * External dependencies
 */
import { combineReducers } from "redux";
import moment from "moment";
import { compact } from "lodash";

/**
 * Internal dependencies
 */
import * as actions from "state/action-types";
import { createReducer } from "state/utils";
import dateParser from "lib/date-parser";

const date = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    return actions.payload.dateRange;
  },
});

const startDate = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    const { dateRange } = actions.payload;
    if (dateRange) {
      try {
        let dates = dateParser(dateRange);
        return moment(dates[0]).format("YYYY-MM-DD:HH:mm:ss");
      } catch (error) {}
    }
    return actions.payload.startDate || null;
  },
});

const endDate = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    const { dateRange } = actions.payload;
    if (dateRange) {
      try {
        let dates = dateParser(dateRange);
        return moment(dates[1]).format("YYYY-MM-DD");
      } catch (error) {}
    }
    return actions.payload.endDate || null;
  },
});

const compareType = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    const { compareType } = actions.payload;
    return compareType || "previous";
  },
});

const compareDate = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    const { dateRange, startDate, endDate, compareType } = actions.payload;

    let mStart;
    let mEnd;

    if (dateRange) {
      try {
        let dates = dateParser(dateRange);
        mStart = moment(dates[0]);
        mEnd = moment(dates[1]);
      } catch (error) {}
    } else {
      mStart = moment(startDate);
      mEnd = moment(endDate);
    }

    if (!mStart.isValid() || !mEnd.isValid()) return null;

    // Include both endpoints for the period
    let dif = mEnd.diff(mStart, "days") + 1;

    if (compareType === "last_year") {
      return [
        mStart.clone().subtract(1, "year").format("YYYY-MM-DD"),
        mEnd.clone().subtract(1, "year").format("YYYY-MM-DD"),
      ];
    }

    // "previous": previous period of the same length, including leap years
    return [
      mStart.clone().subtract(dif, "days").format("YYYY-MM-DD"),
      mEnd.clone().subtract(dif, "days").format("YYYY-MM-DD"),
    ];
  },
});

export default combineReducers({
  date,
  startDate,
  endDate,
  compareDate,
  compareType,
});
